// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ServerRef, ServerRefT, verifyServerRef } from "./server-ref";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Nested channel reference used by BankLight (includes nested server).
 */
export class ChannelRef implements flatbuffers.IUnpackableObject<ChannelRefT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ChannelRef {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsChannelRef(bb: flatbuffers.ByteBuffer, obj?: ChannelRef): ChannelRef {
    return (obj || new ChannelRef()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsChannelRef(bb: flatbuffers.ByteBuffer, obj?: ChannelRef): ChannelRef {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ChannelRef()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  server(obj?: ServerRef): ServerRef | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new ServerRef()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startChannelRef(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addServer(builder: flatbuffers.Builder, serverOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, serverOffset, 0);
  }

  static endChannelRef(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  unpack(): ChannelRefT {
    return new ChannelRefT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.server() !== null ? this.server()!.unpack() : null,
    );
  }

  unpackTo(_o: ChannelRefT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.server = this.server() !== null ? this.server()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ChannelRefT {
    const t = new ChannelRefT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("server")) {
      t.server = this.server() !== null ? this.server()!.unpack() : null;
    }
    return t;
  }
}

export class ChannelRefT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public server: ServerRefT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const server = this.server !== null ? this.server!.pack(builder) : 0;

    ChannelRef.startChannelRef(builder);
    ChannelRef.addId(builder, id);
    ChannelRef.addName(builder, name);
    ChannelRef.addServer(builder, server);

    return ChannelRef.endChannelRef(builder);
  }

  clone(): ChannelRefT {
    const obj = new ChannelRefT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.server = this.server !== null ? this.server!.clone() : null;
    return obj;
  }

  equals(other: ChannelRefT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.server !== null && other.server !== null) {
      if (!this.server!.equals(other.server!)) return false;
    } else if (this.server !== other.server) return false;
    return true;
  }
}

export function verifyChannelRef(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyServerRef(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
